import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $links?: boolean;
  $business?: boolean;
}

function linksStyle({ $links }: Props) {
  if ($links) {
    return css`
      background: ${Colours.whiteDark1};
      border-bottom: 1px solid ${Colours.greyLight6};

      &, a {
        font-size: 0.933333rem;
        text-decoration: none;
        color: ${Colours.slate};
        font-weight: 500;
        line-height: 1.7 !important;
      }

      a {
        &:hover {
          text-decoration: underline;
        }
      }
    `;
  }
}

function businessStyle({ $business }: Props) {
  if ($business) {
    return css`
      background: ${Colours.whiteDark1};
      border-top: 1px solid ${Colours.greyLight4};

      > div {
        padding-top: 1rem;
        padding-bottom: 1rem;
        color: ${Colours.grey};
      }
    `;
  }
}

export default styled.div<Props>`
  background: ${Colours.white};
  border-top: 1px solid ${Colours.greyLight6};
  width: 100%;
  ${linksStyle}
  ${businessStyle}
`;
